/**
 * Lazy self-hosted <video> loader.
 *
 * Markup: <video data-lazy-video muted loop playsinline preload="none">
 *           <source data-src="....mp4" type="video/mp4">
 *         </video>
 *
 * The MP4 is only fetched when the video approaches the viewport. Autoplay
 * matches the live theme's behaviour; users with prefers-reduced-motion get
 * a paused video with controls instead.
 */
const videos = document.querySelectorAll('video[data-lazy-video]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const load = (video) => {
  video.querySelectorAll('source[data-src]').forEach((source) => {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  });
  video.load();
  if (reducedMotion) {
    video.controls = true;
  } else {
    video.play().catch(() => {
      /* Autoplay might be blocked; leave the poster/first frame. */
    });
  }
};

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    },
    { rootMargin: '300px 0px' }
  );
  videos.forEach((video) => observer.observe(video));
} else {
  videos.forEach(load);
}

/**
 * Eager (LCP) videos — e.g. the first hero slide. The markup already plays
 * on its own (autoplay + preload="metadata" + poster, no IO delay); here we
 * only nudge play() for browsers that stall on preload="metadata", and give
 * prefers-reduced-motion users a paused video with controls instead.
 */
document.querySelectorAll('video[data-eager-video]').forEach((video) => {
  if (reducedMotion) {
    video.autoplay = false;
    video.pause();
    video.controls = true;
  } else {
    video.play().catch(() => {
      /* Autoplay might be blocked; the poster stays visible. */
    });
  }
});
